// Optional localStorage debug log. Off by default; enable by uncommenting
// saveEventToStorage(eventData.event, eventData) in index.js#pushEventToDataLayer.

const GTM_EVENTS_STORAGE_KEY = 'gtm_events_log'
const MAX_STORED_EVENTS = 50

export function getStoredEvents() {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return []
  try {
    const raw = localStorage.getItem(GTM_EVENTS_STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (err) {
    console.warn('[GTM] Failed to read events from localStorage:', err)
    return []
  }
}

export function clearStoredEvents() {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return
  try {
    localStorage.removeItem(GTM_EVENTS_STORAGE_KEY)
    console.log('[GTM] All event logs cleared')
  } catch (err) {
    console.warn('[GTM] Failed to clear localStorage:', err)
  }
}

export function getStoredEventsByType(eventType) {
  return getStoredEvents().filter((log) => log.eventType === eventType)
}

export function getLastNEvents(count) {
  return getStoredEvents().slice(0, count)
}

export function printStoredEvents() {
  const events = getStoredEvents()
  if (events.length === 0) {
    console.log('[GTM] No events stored in localStorage')
    return
  }
  console.log(`[GTM] Total ${events.length} events stored in localStorage:\n`)
  events.forEach((log, index) => {
    console.group(
      `${index + 1}. ${log.eventType} - ${new Date(log.timestamp).toLocaleString('tr-TR')}`
    )
    console.log(log.eventData)
    console.groupEnd()
  })
  console.log('\n[GTM] Tip: clearStoredEvents() to clear logs')
}

export function saveEventToStorage(eventType, eventData) {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return
  try {
    const existing = getStoredEvents()
    existing.unshift({
      timestamp: new Date().toISOString(),
      eventType,
      eventData,
    })
    localStorage.setItem(
      GTM_EVENTS_STORAGE_KEY,
      JSON.stringify(existing.slice(0, MAX_STORED_EVENTS))
    )
  } catch (err) {
    console.warn('[GTM] Failed to save event to localStorage:', err)
  }
}
